import * as React from "react";

/** Touch devices get the phone's own pickers and keypads; a mouse gets styled, searchable lists. */
export const TouchContext = React.createContext(true);
